import React, { createContext, useContext, useEffect } from 'react';
import { useDirection } from '../hooks/useDirection';

const DirectionContext = createContext('rtl');

export const DirectionProvider = ({ children }) => {
  const direction = useDirection();

  useEffect(() => {
    // Update HTML dir attribute when direction changes
    document.documentElement.dir = direction;
  }, [direction]);

  return (
    <DirectionContext.Provider value={direction}>
      {children}
    </DirectionContext.Provider>
  );
};

export const useDirectionContext = () => {
  const context = useContext(DirectionContext);
  if (context === undefined) {
    throw new Error('useDirectionContext must be used within a DirectionProvider');
  }
  return context;
};
